/*ěščřžýáíéúů*/

// FAQs Component JavaScript
document.addEventListener("DOMContentLoaded", function () {
    // FAQs Show More Functionality
    const showMoreBtn = document.querySelector(".faqs-show-more-btn");

    if (showMoreBtn) {
        showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();

            const hiddenItems = document.querySelectorAll(".items__item--hidden");

            hiddenItems.forEach(function (item) {
                item.classList.remove("items__item--hidden");
            });

            // Hide the button after showing all items
            const showMoreContainer = document.querySelector(".faqs__show-more");
            if (showMoreContainer) {
                showMoreContainer.style.display = "none";
            }
        });
    }

    // FAQs Search Functionality
    const searchInput = document.getElementById("faq-search");
    const searchBtn = document.getElementById("faq-search-btn");

    function performSearch() {
        const searchTerm = searchInput.value.toLowerCase().trim();

        if (searchTerm === "") return;

        // First check if it matches any section title
        const faqSections = document.querySelectorAll(".faqs");
        let matchedSection = null;

        faqSections.forEach(function (section) {
            const sectionTitle = section.querySelector("h2");
            if (sectionTitle && sectionTitle.textContent.toLowerCase().includes(searchTerm)) {
                matchedSection = section;
            }
        });

        // If section title matches, scroll to that section
        if (matchedSection) {
            matchedSection.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
            return;
        }

        // Otherwise search within FAQ items
        const faqItems = document.querySelectorAll(".items__item");
        let firstMatch = null;

        faqItems.forEach(function (item) {
            const title = item.querySelector(".faq-header p");
            const description = item.querySelector(".faq-description");

            let textContent = "";
            if (title) textContent += title.textContent.toLowerCase();
            if (description) textContent += " " + description.textContent.toLowerCase();

            if (textContent.includes(searchTerm)) {
                item.style.display = "flex";
                item.classList.remove("items__item--hidden");

                if (!firstMatch) {
                    firstMatch = item;
                }
            } else {
                item.style.display = "none";
            }
        });

        // Hide show more button during search
        const showMoreContainer = document.querySelector(".faqs__show-more");
        if (showMoreContainer) {
            showMoreContainer.style.display = "none";
        }

        // Scroll to first matched FAQ item
        if (firstMatch) {
            firstMatch.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }

    if (searchInput) {
        // Live search as user types and deletes
        searchInput.addEventListener("input", function () {
            const searchTerm = this.value.toLowerCase().trim();
            const faqItems = document.querySelectorAll(".items__item");
            let hasVisibleItems = false;

            if (searchTerm === "") {
                // Reset to original state when search is cleared
                const faqSections = document.querySelectorAll(".faqs");

                // Reset all FAQ sections to visible
                faqSections.forEach(function (section) {
                    section.style.display = "";
                });

                // Reset each section individually
                faqSections.forEach(function (section) {
                    const sectionItems = section.querySelectorAll(".items__item");

                    sectionItems.forEach(function (item, index) {
                        // Reset inline styles
                        item.style.display = "";

                        // Show first 7 items in each section, hide the rest
                        if (index >= 7) {
                            item.classList.add("items__item--hidden");
                        } else {
                            item.classList.remove("items__item--hidden");
                        }
                    });
                });

                // Show all show more buttons if there are more than 7 items in each section
                const showMoreContainers = document.querySelectorAll(".faqs__show-more");
                showMoreContainers.forEach(function (container) {
                    const section = container.closest(".faqs");
                    const sectionItems = section.querySelectorAll(".items__item");
                    if (sectionItems.length > 7) {
                        container.style.display = "flex";
                    }
                });

                // Hide no results message
                const noResultsMsg = document.querySelector(".faq-no-results");
                if (noResultsMsg) {
                    noResultsMsg.style.display = "none";
                }

                return;
            }

            // Perform search when there's a search term
            const faqSections = document.querySelectorAll(".faqs");

            faqSections.forEach(function (section) {
                const sectionTitle = section.querySelector("h2");
                const sectionItems = section.querySelectorAll(".items__item");
                let sectionHasVisibleItems = false;

                // Search within section - both title and items
                sectionItems.forEach(function (item) {
                    const title = item.querySelector(".faq-header p");
                    const description = item.querySelector(".faq-description");

                    let textContent = "";
                    if (title) textContent += title.textContent.toLowerCase();
                    if (description) textContent += " " + description.textContent.toLowerCase();

                    // Also include section title in search for each item
                    if (sectionTitle) textContent += " " + sectionTitle.textContent.toLowerCase();

                    if (textContent.includes(searchTerm)) {
                        item.style.display = "flex";
                        item.classList.remove("items__item--hidden");
                        sectionHasVisibleItems = true;
                        hasVisibleItems = true;
                    } else {
                        item.style.display = "none";
                    }
                });

                // Hide section if no items match
                if (!sectionHasVisibleItems) {
                    section.style.display = "none";
                } else {
                    section.style.display = "";
                }

                // Hide show more button for this section during search
                const showMoreContainer = section.querySelector(".faqs__show-more");
                if (showMoreContainer) {
                    showMoreContainer.style.display = "none";
                }
            });

            // Show no results message if needed
            let noResultsMsg = document.querySelector(".faq-no-results");
            if (!hasVisibleItems) {
                if (!noResultsMsg) {
                    noResultsMsg = document.createElement("div");
                    noResultsMsg.className = "faq-no-results";
                    noResultsMsg.innerHTML = "<p>Žádné FAQ neodpovídají vašemu hledání.</p>";

                    const itemsContainer = document.querySelector(".items");
                    if (itemsContainer) {
                        itemsContainer.appendChild(noResultsMsg);
                    }
                } else {
                    noResultsMsg.style.display = "block";
                }
            } else if (noResultsMsg) {
                noResultsMsg.style.display = "none";
            }
        });

        // Search on Enter key
        searchInput.addEventListener("keypress", function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                performSearch();
            }
        });
    }

    // Search on button click
    if (searchBtn) {
        searchBtn.addEventListener("click", function () {
            performSearch();
        });
    }
});
